import * as React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { colors } from "./colorsPalettes";
import { lineElementClasses } from "@mui/x-charts";

const LineChartCustom = ({ xLabels, series, yAxis = [{ min: 0 }], marginBottom = 50, tickLabelStyle = {} }) => {
  return (
    <LineChart
      height={400}
      margin={{ bottom: marginBottom, top: 80 }}
      series={series}
      xAxis={[
        {
          scaleType: "point",
          data: xLabels,
          tickLabelStyle,
        },
      ]}
      yAxis={yAxis}
      colors={colors}
      grid={{ vertical: false, horizontal: true }}
      sx={{
        [`& .${lineElementClasses.root}`]: {
          strokeWidth: 3,
        },
        // Add dashed grid lines
        [`& .MuiSvgGridLine-horizontal`]: {
          strokeDasharray: "5 5", // Makes the horizontal grid lines dashed
        },
        [`& .MuiSvgGridLine-vertical`]: {
          strokeDasharray: "5 5", // Makes the vertical grid lines dashed (if you want)
        },
      }}
    />
  );
};

export default LineChartCustom;
